import HistoriaClinicaDigital from "./HistoriaClinicaDigital";
export default HistoriaClinicaDigital;